'use client';

import React__default, { useState } from 'react';
import { Container, TabWrap, PanelWrap } from './styles/index.css.js';
import Tab from './components/Tab.js';
import Panel from './components/Panel.js';

function Tabs(_a) {
    var labels = _a.labels, contentPanels = _a.contentPanels, autoActive = _a.autoActive, disableTabs = _a.disableTabs;
    var _b = useState(autoActive !== null && autoActive !== void 0 ? autoActive : 0), indexTab = _b[0], setIndexTab = _b[1];
    var onChangeTab = function (index) {
        setIndexTab(index);
    };
    return (React__default.createElement(Container, null,
        React__default.createElement(TabWrap, null, labels.map(function (item, index) {
            var _a;
            return (React__default.createElement(Tab, { disable: (_a = (disableTabs && disableTabs.includes(index))) !== null && _a !== void 0 ? _a : false, active: index === indexTab, label: item, id: index, key: "".concat(item, "_").concat(index), onChangeTab: onChangeTab }));
        })),
        React__default.createElement(PanelWrap, null, contentPanels.map(function (content, index) {
            if (index !== indexTab)
                return;
            return React__default.createElement(Panel, { key: index }, content);
        }))));
}

export { Tabs as default };
//# sourceMappingURL=index.js.map
